var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":"Maintain","name":"Maintain"}},[_c('MaintainTab')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }